var makeString = require('./helper/makeString');

module.exports = function strRight(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/strRight.js
// module id = 456
// module chunks = 0